import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { filterTabsData } from "@sunSource/Common/Utilities/TabsFilterUtils";
import { CustomApiHandler } from "@sunSource/Store/CustomHandlerCreator";
import sortBy from "lodash/sortBy";

type HandlerType = CustomApiHandler<{ tabsSearchTerm?: string | "", tagsName?: string | " " }>;

const normalize = (value?: string) => value?.trim().toLowerCase() ?? "";

export const DispatchSearchTermsNewslIstDataLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/TabsDataState/loading",
        isLoading: true,
    });
};

export const DispatchSearchTermNewslistData: HandlerType = async props => {
    const state = props.getState();
    const parameter = state.pages.newsList.getNewsPagesParameters[getCurrentPage(state).nodeId] ?? {
        parentNodeId: getCurrentPage(state).nodeId,
    }
    const page = parameter.page ?? 1;
    const pageSize = parameter.pageSize ?? 10;
    const start = (page - 1) * pageSize;
    const end = start + pageSize;

    const searchTerm = normalize(props.parameter.tabsSearchTerm);

    const tagsName = normalize(props.parameter.tagsName);

    const activeTabData = state.sunSourceState.TabsActiveData.listActiveTabData;
    
    const pages = getDataView(state.data.pages, { parentNodeId: getCurrentPage(state).nodeId });
    const sortedAndPagedPages = (pages?.value?.length ?? 0) > 0 ? sortBy(pages.value, o => o.fields["publishDate"]).reverse() : []
    
    const data = activeTabData?.length ? activeTabData : sortedAndPagedPages ?? [];
    
    const tagsArray = tagsName
        ? tagsName.split(",").map(tag => tag.trim().toLowerCase())
        : [];
    
    const filteredData = filterTabsData(data, searchTerm, tagsArray, state);
   
    props.dispatch({
        type: "Custom/TabsDataState/listActiveTab",
        listActiveTabData: filteredData,
    });
};

export const DispatchTabsSearchTerm: HandlerType = props => {
    const searchTerm = props.parameter.tabsSearchTerm;
    if (!searchTerm) return;
    props.dispatch({
        type: "Custom/TabsDataState/searchTerm",
        tabsSearchTerm: searchTerm,
    });
};

export const DispatchTagsName: HandlerType = props => {
    const tag = normalize(props.parameter.tagsName);
    if (!tag) return;
    props.dispatch({
        type: "Custom/TabsDataState/tagsName",
        tagsName: tag,
    });
}


export const chain = [DispatchSearchTermsNewslIstDataLoading, DispatchSearchTermNewslistData, DispatchTabsSearchTerm, DispatchTagsName];

const TabsSearchTermHandler = createHandlerChainRunner(chain, "TabsSearchTerm");
export default TabsSearchTermHandler;
